class LoadingCircle {
    init() {
      this.loadingCircle = document.querySelector('.loading-circle');
    }
  
    show(targetDiv) {
      const rect = targetDiv.getBoundingClientRect();
      const top = rect.top + (rect.height / 2);
      const left = rect.left + (rect.width / 2);
  
      this.loadingCircle.style.top = `${top - 20}px`;  // half of width and height to perfectly center it
      this.loadingCircle.style.left = `${left - 20}px`;
  
      this.loadingCircle.style.position = 'absolute';
      targetDiv.style.position = 'relative';
  
      this.loadingCircle.style.display = 'block';
    }
  
    hide() {
      this.loadingCircle.style.display = 'none';
    }
  }

  module.exports = new LoadingCircle();